import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
// import { SiWindows11 } from "react-icons/si";

const QuestionChange = ({
  quizTestsQuestions = [],
  setCurrentPage,
  currentPage,
  answers,
}) => {
  const itemsPerPage = 1;
  const totalPages = Math.ceil(quizTestsQuestions.length / itemsPerPage);
  const maxVisibleButtons = window.innerWidth <= 768 ? 5 : totalPages;
  const VISIBLE_COUNT = 4;

  const isAnswered = (questionId) => {
    return answers.some(
      (answer) =>
        answer.questionId === questionId &&
        answer.selectedAnswer != null // handles both null and undefined
    );
  };

  const isFlagged = (questionId) => {
    return answers.some(
      (answer) => answer.questionId === questionId && answer.flag === true,
    );
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getQuestionStatus = (index) => {
    const questionId = quizTestsQuestions[index]?._id;
    if (isFlagged(questionId)) return "orange-color";
    if (isAnswered(questionId)) return "green-color";
    return "page-link-color";
  };

  const getPageNumbers = () => {
    const pages = [];
    const FIRST_COUNT = 4;
    const LAST_COUNT = 4;

    // First 4 pages
    for (let i = 0; i < FIRST_COUNT && i < totalPages; i++) {
      pages.push(i);
    }

    // Show dots if gap exists after first
    if (currentPage > FIRST_COUNT) {
      pages.push("...");
    }

    // Current page (middle)
    if (
      currentPage >= FIRST_COUNT &&
      currentPage < totalPages - LAST_COUNT
    ) {
      pages.push(currentPage - 1);
      pages.push(currentPage);
      pages.push(currentPage + 1);
    }

    // Show dots before last
    if (currentPage < totalPages - LAST_COUNT - 1) {
      pages.push("...");
    }

    // Last 4 pages
    for (
      let i = Math.max(totalPages - LAST_COUNT, FIRST_COUNT);
      i < totalPages;
      i++
    ) {
      pages.push(i);
    }

    // Remove duplicates
    return [...new Set(pages)].filter(
      (p) => p >= 0 && p < totalPages || p === "..."
    );
  };


  return (
    <div className='row mx-0'>
      <div className='col-lg-12 d-flex align-items-center justify-content-center gap-2'>
        <div className='pagination d-flex'>
          <span
            className='page-link pt-0 fs-5'
            onClick={handlePreviousPage}
            style={{ cursor: currentPage === 0 ? "not-allowed" : "pointer" }}
          >
            <FaAngleLeft />
          </span>
          {getPageNumbers().map((num, index) => (
            <span
              key={index}
              className={`page-link ${num === "..." ? "disabled" : getQuestionStatus(num)
                }
              ${currentPage === num ? "active" : ""}`}
              onClick={() => num !== "..." && setCurrentPage(num)}
              style={{ cursor: num === "..." ? "default" : "pointer" }}
            >
              {num === "..." ? "..." : num + 1}
            </span>
          ))}
          <span
            className='page-link pt-0 fs-5'
            onClick={handleNextPage}
            style={{
              cursor:
                currentPage === totalPages - 1 ? "not-allowed" : "pointer",
            }}
          >
            <FaAngleRight />
          </span>
        </div>
      </div>
    </div>
  );
};

export default QuestionChange;
